<template>
  <Modal
    title="报告单上传"
    width="800"
    :value="value"
    @on-visible-change="onVisibleChange"
    :mask-closable="false"
    @on-cancel="onVisibleChange(false)"
  >
    <Form
      ref="editForm"
      :model="editData"
      :rules="editRules"
      inline
      :label-width="125"
    >
      <Row>
        <Col span="12">
        <FormItem
          label="产品编码"
          prop="skuCode"
        >
          <Input
            type="text"
            v-model="editData.skuCode"
            placeholder="请输入产品编码"
          >
          </Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem
          label="产品名称"
          prop="skuName"
        >
          <Input
            type="text"
            v-model="editData.skuName"
            placeholder="请输入产品名称"
          >
          </Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem
          label="批次号"
          prop="pici"
        >
          <Input
            type="text"
            v-model="editData.pici"
            placeholder="请输入批次号"
          >
          </Input>
        </FormItem>
        </Col>
      </Row>
      <FormItem
        label="附件名称"
        prop="fujianAddr"
        style="width:100%"
      >
        <Upload
          type="drag"
          :on-success="onUploadSuccess"
          :default-file-list="defaultFileList"
          action="/api/haf-web/CusFahuo/uploadFahuo"
        >
          <div style="padding: 20px 0">
            <Icon
              type="ios-cloud-upload"
              size="52"
              style="color: #3399ff"
            ></Icon>
            <p>点击或文件拖拽进行上传</p>
          </div>
        </Upload>
      </FormItem>
      <FormItem label="">{{editData.fujianAddr}}</FormItem>
      <Row>
        <Col
          span='8'
          offset='10'
          class="btn-groups"
        >
        <Button
          type="primary"
          @click="clickSave"
        >保存</Button>
        <Button
          type="default"
          @click="clickCancel"
        >取消</Button>
        </Col>
      </Row>
    </Form>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import CTable from '@/components/CTable'
import BtnEvent from '@/components/BtnEvent'
import {areaRule} from '@/plugin/validateRule'
import {timeFormat} from '@/plugin/tool'
export default {
  name: 'EditModal',
  mixins: [BtnEvent],
  components: {
    CTable
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Boolean
  },
  watch: {
  },
  data () {
    return {
      defaultFileList: [],
      editData: {
        id: null,
        skuCode: null,
        skuName: '',
        pici: '',
        fujianAddr: ''
      },
      editRules: {
        id: [
          {required: false,message: 'The name cannot be empty',trigger: 'blur'}
        ],
        skuCode: [
          {required: true,message: '产品编码',trigger: 'blur'}
        ],
        skuName: [
          {required: true,message: '产品名称',trigger: 'blur'}
        ],
        pici: [
          {required: true,message: '批次号',trigger: 'blur'}
        ],
        fujianAddr: [
          {required: true,message: '附件名称',trigger: 'blur'}
        ],
      }
    }
  },
  created () {
  },
  methods: {
    setData (data) {
      this.editData=data
    },
    deleteAction (p) {
      this.$emit('on-delete',p)
    },
    onVisibleChange (value) {
      if(this.value!==value) {
        this.$emit('change',value)
      }
      if(value) {
        this.$refs['editForm'].resetFields();
      }
    },
    clickCancel () {
      this.$emit('change',false)
    },
    onUploadSuccess (res,file,fileList) {
      this.editData.fujianAddr=res.data.picName
    },
    clickSave () {
      this.$refs['editForm'].validate((valid) => {
        if(valid) {
          this.$emit('on-save',this.editData)
        } else {
          this.$Message.error('Fail!');
        }
      })
    }
  }
}
</script>
<style >
.ivu-upload {
  width: 100%;
}
</style>
